import { Currency } from '../../sdk'
import { useCurrency } from '../../hooks/Tokens'

import { useResolveSwapCurrency } from './useResolveSwapCurrency'

/** Resuelve moneda de sesión: wallet primero, catálogo de la app (estático + market API) como respaldo. */
export function useSessionCurrency(currencyId: string | undefined): Currency | undefined {
  const fromWallet = useCurrency(currencyId)
  const fromCatalog = useResolveSwapCurrency(currencyId)

  if (fromWallet) return fromWallet
  if (fromCatalog) return fromCatalog
  return undefined
}
